import React, { PropsWithChildren } from "react";

import { getContentAssetsListHref } from "../../../assets/AssetsRoutes";
import { ContentDetails, mapToContentAssetsListHrefContent } from "./AssetOperationListItem";
import { AssetsLinkSection } from "./AssetsLinkSection";

type AssetOperationProps = PropsWithChildren<{
    isQcDoneConfirmed: boolean;
}>;

export const AssetOperationSection = ({ children, isQcDoneConfirmed }: AssetOperationProps): JSX.Element => {
    const [assetContent, setAssetContent] = React.useState<ContentDetails>();

    if (isQcDoneConfirmed && assetContent) {
        return <AssetsLinkSection href={getContentAssetsListHref(mapToContentAssetsListHrefContent(assetContent))} />;
    }

    const extendedChildren = React.Children.map(children, (child) =>
        React.isValidElement(child) ? React.cloneElement(child, { ...child.props, setAssetContent }) : child
    );

    return <>{extendedChildren}</>;
};
